import { apiAction, appendQuery } from 'client/redux/apiHelpers';

export const instanceEatdReadStatistics = (types, id, statistic, query) => {
  return apiAction({
    endpoint: appendQuery(`/api/instance/${id}/statistics/${statistic}`, query),
    method: 'GET',
    types: types.map(type => ({type, meta: {statistic}})),
  });
};

export const instanceEatdReadMeta = (types, id) => {
  return apiAction({
    endpoint: `/api/instance/${id}/view`,
    method: 'GET',
    types: types.map(type => ({type, meta: {id}})),
  });
};

export const instanceEatdTestOperatorAdd = (types, id, topdeskOperatorId) => {
  const meta = {topdeskOperatorId};
  return apiAction({
    endpoint: `/api/instance/eatd-operator/${id}/test/operator/${topdeskOperatorId}`,
    method: 'GET',
    types: types.map(type => ({type, meta})),
  });
};

export const instanceEatdAnonymizeOperator = (types, id, topdeskOperatorId, query) => {
  const meta = {topdeskOperatorId};
  return apiAction({
    endpoint: appendQuery(`/api/instance/eatd-operator/${id}/anonymize/operator/${topdeskOperatorId}`, query),
    method: 'POST',
    types: types.map(type => ({type, meta})),
  });
};

export const instanceEatdTestOperatorRemove = (type, topdeskOperatorId) => {
  return {type, topdeskOperatorId};
};

// --- Incident / Person / Change add actions mirroring operator pattern ---

export const instanceEatdTestIncidentAdd = (types, id, incidentId) => {
  const meta = { incidentId };
  return apiAction({
    endpoint: `/api/instance/eatd-incident/${id}/preview/${incidentId}`,
    method: 'GET',
    types: types.map(type => ({ type, meta })),
  });
};

export const instanceEatdTestPersonAdd = (types, id, personId) => {
  const meta = { personId };
  return apiAction({
    endpoint: `/api/instance/eatd-person/${id}/preview/${personId}`,
    method: 'GET',
    types: types.map(type => ({ type, meta })),
  });
};

export const instanceEatdTestChangeAdd = (types, id, changeId) => {
  const meta = { changeId };
  return apiAction({
    endpoint: `/api/instance/eatd-change/${id}/preview/${changeId}`,
    method: 'GET',
    types: types.map(type => ({ type, meta })),
  });
};